module.exports = __webpack_public_path__ + "img/tabs_a_active.a7b647df.png";